import React, { memo, useMemo } from 'react';
import { createUseStyles, Loader } from '@Sage/hoi-poi-ui';
import ContentLoader from 'react-content-loader';
import { theme } from "../../lib/styles/theme";
import styles from "./styles/loadingOverlay.styles";
const useStyles = createUseStyles(styles, 'LoadingOverlay');
var _ref2 = /*#__PURE__*/React.createElement(Loader, {
  size: "massive"
});
const LoadingOverlay = /*#__PURE__*/memo(_ref => {
  var _baseElement, _baseElement$querySel, _baseElement2, _baseElement2$querySe, _baseElement3, _baseElement3$querySe, _gridContext$current;
  let {
    id,
    useLoaderPlaceholder,
    loaderRowHeight,
    loaderRows = 11,
    loaderColumns,
    useLoaderFullHeight,
    placeholderOptions = {
      avatars: true
    },
    gridContext
  } = _ref;
  const classes = useStyles();
  const {
    avatars
  } = placeholderOptions;
  let baseElement = document;
  if (id) baseElement = document.getElementById(id);
  const baseHeaderHeight = ((_baseElement = baseElement) === null || _baseElement === void 0 ? void 0 : (_baseElement$querySel = _baseElement.querySelector('.ag-header')) === null || _baseElement$querySel === void 0 ? void 0 : _baseElement$querySel.clientHeight) || 0;
  const width = ((_baseElement2 = baseElement) === null || _baseElement2 === void 0 ? void 0 : (_baseElement2$querySe = _baseElement2.querySelector('.ag-body-viewport')) === null || _baseElement2$querySe === void 0 ? void 0 : _baseElement2$querySe.clientWidth) || 0;
  const height = (((_baseElement3 = baseElement) === null || _baseElement3 === void 0 ? void 0 : (_baseElement3$querySe = _baseElement3.querySelector('.ag-root')) === null || _baseElement3$querySe === void 0 ? void 0 : _baseElement3$querySe.clientHeight) || 0) + baseHeaderHeight;
  const verticalElements = useMemo(() => {
    const rowHeight = loaderRowHeight || 50;
    const commonElementWidth = 190 + 80;
    let numRows = loaderRows;
    if (useLoaderFullHeight) numRows = Math.ceil(height / rowHeight);
    let numColumns = Math.ceil(width / commonElementWidth);
    if (loaderColumns) numColumns = loaderColumns;
    const circleHeight = 24;
    const firstRectangleWidth = 205;
    const rectangleHeight = 20;
    const rectangleWidth = 240;
    const rectangleRadius = 4;
    const baseMarginLeft = 16;
    const firstCircleY = (rowHeight - circleHeight) / 2 + baseHeaderHeight;
    const firstRectangleY = (rowHeight - rectangleHeight) / 2 + baseHeaderHeight;
    const marginY = rowHeight;
    let elements = [];
    let sumCircleY = firstCircleY;
    let sumRectangleY = firstRectangleY;
    const firstRectangleX = !avatars ? baseMarginLeft + baseMarginLeft / 2 : baseMarginLeft + circleHeight + baseMarginLeft / 2;
    let sumMarginX = firstRectangleX + rectangleWidth;
    for (let i = 0; i < numRows; i++) {
      if (i === 0) {
        if (avatars) elements.push(/*#__PURE__*/React.createElement("rect", {
          key: `fc${i}`,
          x: baseMarginLeft,
          y: sumCircleY,
          rx: circleHeight,
          ry: circleHeight,
          width: circleHeight,
          height: circleHeight
        }));
        elements.push(/*#__PURE__*/React.createElement("rect", {
          key: `fr${i}`,
          x: firstRectangleX,
          y: sumRectangleY,
          rx: rectangleRadius,
          width: firstRectangleWidth,
          height: rectangleHeight
        }));
      } else {
        sumCircleY = sumCircleY + marginY;
        sumRectangleY = sumRectangleY + marginY;
        if (avatars) elements.push(/*#__PURE__*/React.createElement("rect", {
          key: `c${i}`,
          x: baseMarginLeft,
          y: sumCircleY,
          rx: circleHeight,
          ry: circleHeight,
          width: circleHeight,
          height: circleHeight
        }));
        elements.push(/*#__PURE__*/React.createElement("rect", {
          key: `r${i}`,
          x: firstRectangleX,
          y: sumRectangleY,
          rx: rectangleRadius,
          width: firstRectangleWidth,
          height: rectangleHeight
        }));
      }
      for (let a = 0; a < numColumns - 1; a++) {
        elements.push(/*#__PURE__*/React.createElement("rect", {
          key: `r${i}-${a}`,
          x: sumMarginX,
          y: sumRectangleY,
          rx: rectangleRadius,
          width: rectangleWidth,
          height: rectangleHeight
        }));
        sumMarginX = sumMarginX + rectangleWidth + baseMarginLeft * 2;
        if (a + 1 === numColumns - 1) {
          sumMarginX = firstRectangleX + rectangleWidth;
        }
      }
    }
    return elements;
  }, [width, height, loaderRowHeight, loaderRows, useLoaderFullHeight, loaderColumns, baseHeaderHeight, avatars]);
  if (useLoaderPlaceholder && !((_gridContext$current = gridContext.current) !== null && _gridContext$current !== void 0 && _gridContext$current.startRow)) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.overlay
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.fadeMask
    }, /*#__PURE__*/React.createElement(ContentLoader, {
      speed: 2,
      width: width,
      height: height,
      viewBox: `0 0 ${width} ${height}`,
      backgroundColor: theme.colors.actionMinor[50],
      foregroundColor: theme.colors.grey[100]
    }, verticalElements)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, _ref2);
});
export default LoadingOverlay;